import { formatter } from 'utils';

/**
 * Format amount with a currencty USD style.
 *
 * @param {number} amount
 * @returns amount formatted or '-' in case of invalid amount
 */
export const formatAmount = amount => (amount ? formatter.format(amount) : '-');
